import { render, staticRenderFns } from "./ElternIcon.vue?vue&type=template&id=7af9f5c1"
import script from "./ElternIcon.vue?vue&type=script&lang=js"
export * from "./ElternIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports